import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption, } from "mdbreact";
import Axios from 'axios'
import { URL,api } from '../../api';
import Swal from 'sweetalert2'

export default class Modalarticleaddexpertbn extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_uploadeword1:"",
   send_uploadepdf1:"",
}

this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectat();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
       this.setState({ id_send:this.props.id_send})
       this.setState({ send_uploadeword1:this.props.send_uploadeword1})
        this.setState({ send_uploadepdf1:this.props.send_uploadepdf1})
      setTimeout(() => {
        //ภายใน
        api.get('registercon/selectexpertenforadmintype')
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ Expert: res.data})
        }) 

      }, 400);

  }

  getExpert() {
    setTimeout(() => {
      //ภายใน
      api.get('registercon/selectexpertenforadmintype')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 400);

}





  handleChange(event) {    this.setState({idExpert: event.target.value});  }
 // handleChange2(event) {    this.setState({faculty: event.target.value});  }

  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

                    setTimeout(() => {

                       // event.preventDefault();
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("idExpert", this.state.idExpert);
                        datafrm.append("idsend", this.state.id_send);

                        api.post("registercon/Insertexpertmaparticle",datafrm,{
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                           })
                        .then(res => {
                        console.log("response: ", res)
                        if (res.data.length !== 0) {
                        // this.showitem = true;
                        console.log(res)
                        console.log(res.data.length) 
                        }else{
                        // window.location.href = '/'
                        }
                    })



                    //อัพเดทสถานะ
                    
                    // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
                   
                    api.post("registercon/updateArticlestatusadmin",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                       })
                        .then(res => {
                        console.log("response: ", res)
                    
                        if (res.data.length !== 0) {
                        // this.showitem = true;
                            console.log(res)
                            console.log(res.data.length)

                            const date = new Date();
                            const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
                            const dates = day+"-"+month+"-"+year ;
                    
                            console.log(dates)


                                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                        datafrm.append("id_sendarticle", this.state.id_send);
                                        datafrm.append("id_experten", this.state.idExpert);
                                        datafrm.append("fileword", this.state.send_uploadeword1);
                                        datafrm.append("filepdf", this.state.send_uploadepdf1);
                                        datafrm.append("date_sentexperten", dates);
                
                                        api.post("registercon/Insertexpertcomment",datafrm,{
                                            headers: {
                                                'content-type': 'multipart/form-data'
                                            }
                                        })
                                        .then(res => {
                                        console.log("response: ", res)
                                        if (res.data.length !== 0) {
                                        // this.showitem = true;
                                        console.log(res)
                                        console.log(res.data.length) 

                                                                Swal.fire({
                                                                    title: 'เพิ่มบรรณาธิการสำเร็จ',
                                                                    text: "Successfully added editor",
                                                                    icon: 'success',
                                                                    showCancelButton: false,
                                                                    confirmButtonColor: '#3085d6',
                                                                    cancelButtonColor: '#d33',
                                                                    confirmButtonText: 'ตกลง'
                                                                }).then((result) => {
                                                                    if (result.isConfirmed) {
                                                                    // Swal.fire(
                                                                    //   'Deleted!',
                                                                    //   'Your file has been deleted.',
                                                                    //   'success'
                                                                    // )
                                                                     this.props.updateat();
                                                                    this.toggle()
                                                                    }
                                                                })

                                        }else{
                                        // window.location.href = '/'
                                        } })


                       



                        }else{
                        // window.location.href = '/'
                        }
                    })
               //     window.location.href = '/superadmincheckadmintype'

                    }, 500);
                    //this.props.updateat();
                //    this.toggle()
                  //  this.getExpert()
  }

  

    render() {
        console.log(this.state.idExpert)
        console.log(this.state.id_send)
        return (
            <MDBContainer>
            <MDBBtn color="secondary" size='sm' onClick={this.toggle}>เลือกบรรณาธิการ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>ชื่อบทความ {this.props.namearticla} </MDBModalHeader>
              <MDBModalBody>
              <div>
              
        <p>เลือกบรรณาธิการ</p>
        <select className="browser-default custom-select" onChange={this.handleChange}>
                   <option>------กรุณาเลือกบรรณาธิการ------</option>
                   {this.state.Expert.map((Expert,index )  => 
                   <option value={Expert.id_expertbn}>{Expert.name_expertbn}</option>
                   )}
        </select>
        
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
        )
    }
}
